import React, { Component } from 'react';
import styled from 'styled-components';
import { TimelineMax, Power1 } from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'; // eslint-disable-line
import FlexBox from '../FlexBox';
import Container from '../Container';
import Icon from '../Icon';
import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';

const PX2VW = 100 / 375;

// eslint-disable-next-line semi
const px2vw = (num: number): string => `${num * PX2VW}vw`;

export const Warp = styled.div`
  display: ${({ display }) => display || 'block'};
  position: relative;
  background: #0b0e11;
  overflow-x: hidden;
`;

export const MobileTextItem = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

export const MobileTextSpan1 = styled.div`
  padding-left: ${px2vw(16)};
  padding-right: ${px2vw(16)};
  display: inline-block;
  color: #212833;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  font-style: normal;
  font-weight: 500;
  font-size: ${px2vw(18)};
  margin-top: ${px2vw(32)};
  line-height: ${px2vw(23)};
`;

export const MobileTextSpan2 = styled(MobileTextSpan1)`
  color: #48515d;
  font-weight: normal;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  font-size: ${px2vw(14)};
  margin-top: ${px2vw(16)};
  line-height: ${px2vw(18)};
  margin-bottom: ${px2vw(32)};
`;

export const MobileText = styled.div`
  margin-top: ${({ marginTop }) => (marginTop ? px2vw(-75) : px2vw(16))};
  /* margin-top: ${px2vw(16)}; */
  width: 100%;
  padding-left: ${px2vw(16)};
    padding-right: ${px2vw(16)};
  /* height: ${px2vw(157)}; */
`;

export const Warp1 = styled.div`
  display: ${({ display }) => display || 'block'};
  position: relative;
  /* background: #0b0e11; */
  overflow-x: hidden;
`;

export const StyletContainer = styled(Container)`
  position: absolute;
  width: 100%;
  margin-left: -50%;
  left: 50%;
`;

export const MobileWrap = styled(Warp1)`
  width: 100vw;
  max-width: 100vw;
  min-width: 100vw;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-size: 100vw auto;
  padding-bottom: ${px2vw(92)};
`;

export const MobileLogo = styled.div`
  padding-top: ${px2vw(24)};
  padding-left: ${px2vw(24)};
  justify-content: left;
`;

export const MobileBaseText = styled.div`
         display: flex;
         flex-direction: column;
         justify-content: left;
         margin-right: ${px2vw(32)};
         margin-left: ${px2vw(40.83)};
         > span:first-child {
           padding-left: ${px2vw(16)};
           padding-right: ${px2vw(16)};
           display: inline-block;
           color: #212833;
           font-family: ${({ theme }) => theme.fontIBMMedium};
           font-style: normal;
           font-weight: 500;
           font-size: ${px2vw(18)};
           /* margin-top: ${px2vw(64)}; */
           line-height: ${px2vw(23)};
         }

         > span:last-child {
           padding-left: ${px2vw(16)};
           padding-right: ${px2vw(16)};
           display: inline-block;
           font-family: ${({ theme }) => theme.fontIBMRegular};
           font-style: normal;
           font-weight: normal;
           font-size: ${px2vw(14)};
           margin-top: ${px2vw(16)};
           line-height: ${px2vw(18)};
           margin-bottom: ${px2vw(32)};
         }
       `;

export const MobileText1 = styled(MobileBaseText)`
         margin-left: ${px2vw(40.83)};
         /* margin-top: ${px2vw(64)}; */
         > span:first-child {
           padding-left: 0;
           /* padding-right: 0; */
           padding-right: ${px2vw(0)};
         }

         > span:last-child {
           padding-left: 0;
           padding-right: 0;
         }
       `;

export const MobileText2 = styled(MobileBaseText)`
  margin-right: ${px2vw(6)};
  /* margin-left: 0; */
  margin-left: ${px2vw(33)};
  margin-top: ${px2vw(54)};
  width: ${px2vw(180)};
  > span:first-child {
    padding-left: 0;
    padding-right: 0;
  }

  > span:last-child {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const MobileText3 = styled(MobileBaseText)`
  margin-left: ${px2vw(29)};
  margin-top: ${px2vw(20)};
  > span:first-child {
    padding-left: 0;
    padding-right: ${px2vw(0)};
    /* margin-top: ${px2vw(50)}; */
  }

  > span:last-child {
    padding-left: 0;
    padding-right: ${px2vw(0)};
  }
`;

export const MobileImageAndText = styled.div`
         width: 100%;
         height: ${px2vw(157)};
         display: flex;
         width: 100%;
         height: 100%;
         justify-content: left;
         /* margin-left: ${px2vw(33)}; */
         margin-top:${px2vw(50)};
         /* margin-right: ${px2vw(16)}; */
       `;

export const MobileTitle = styled.div`
  padding-top: ${px2vw(16)};
  padding-left: ${px2vw(24)};
  display: flex;
  justify-content: left;
  background: url(${require('./newImage/mobileTitle.png')});
  background-repeat: no-repeat;
  background-size: ${px2vw(167.49)} ${px2vw(223.15)};
  background-position: bottom right;
  height: ${px2vw(310)};
  /* overflow: hidden; */
`;

export const MobileTitleItem = styled.div`
  width: ${px2vw(232)};
  height: ${px2vw(120)};
  font-family: ${({ theme }) => theme.fontIBMMedium};
  font-style: normal;
  font-weight: 600;
  font-size: ${px2vw(32)};
  line-height: ${px2vw(40)};
  color: #212833;
`;

export const MobileBtn = styled(FlexBox)`
  flex: 1;
  margin-right: ${px2vw(15)};
  /* border: 1px solid rgba(255, 255, 255, 0.6); */
  box-sizing: border-box;
  border-radius: ${px2vw(5)};
  height: ${px2vw(48)};
  justify-content: center;
  align-items: center;
  background: ${({ isApple }) => isApple ? 'linear-gradient(90deg, #F0B90B 0%, #FBDA3C 100%)' : '#000'};
  &:last-child {
    margin-right: 0;
  }
  i {
    font-size: ${px2vw(34)};
    margin-right: ${px2vw(16)};
  }
  span {
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-style: normal;
    font-weight: 500;
    font-size: ${px2vw(10)};
    line-height: ${px2vw(13)};
    color: ${({ isApple }) => (isApple ? '#212833' : '#FFF')};
  }
  strong {
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-style: normal;
    font-weight: 600;
    font-size: ${px2vw(16)};
    line-height: ${px2vw(21)};
    color: ${({ isApple }) => (isApple ? '#212833' : '#fff')};
  }
`;

export const MobileBtnWrap = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  height: ${px2vw(64)};
  padding: 0 ${px2vw(8)};
  background: #fff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  z-index: 100000;
`;

export const GooglePlay = styled(FlexBox)`
  width: ${px2vw(24)};
  height: ${px2vw(26)};
  margin-right: ${px2vw(13)};
`;

export const BinanceIcon = styled(FlexBox)`
  width: ${px2vw(32)};
  height: ${px2vw(30)};
  margin-right: ${px2vw(13.55)};
`;

export const Andriod = styled(FlexBox)`
  width: ${px2vw(22.45)};
  height: ${px2vw(25.98)};
  margin-right: ${px2vw(13.55)};
`;

export const ItemBox = styled(FlexBox)`
  width: 1260;
  margin: 0 auto;
  height: 100vh;
  padding: 200px 0;
  background-color: #0b0e11;

  position: relative;
  & img {
    display: inline-block;
  }
`;
export const WrapImg = styled.div`
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translateY(-50%);
  z-index: 100;
  & img {
    width: auto;
    height: 560px;
    display: inline-block;
  }
  &.top {
    z-index: 100;
  }
  &.top1 {
    z-index: 99;
  }
  &.top2 {
    z-index: 98;
  }
`;
export const ItemContent = styled.div`
  width: 100%;
`;

export const Title = styled.h3`
  font-size: 54px;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  font-weight: 300;
  color: rgba(255, 255, 255, 1) !important;
  line-height: 60px;
  margin-bottom: 40px;
`;

export const SloganPre = styled.p`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 32px;
`;

export const Slogan = styled.p`
  max-width: 660px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 32px;
  margin-bottom: 80px;
`;

export const LinkBox = styled(FlexBox)`
  width: 100%;
  > a {
    margin-right: 20px;
    :last-of-type {
      margin: 0;
    }
  }
`;

export const LinkButton = styled.a`
  display: flex;
  align-items: center;
  position: relative;
  padding: 5px ${({ padding = 25 }) => padding}px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  transition: all 0.3s ease-in-out;
  :hover {
    border-color: #fff;
  }
  > div {
    line-height: 100%;
    margin-left: 20px;
    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      display: inline-block;
      margin-bottom: 8px;
    }
    strong {
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
  }
  & .dropdown {
    display: none;
  }
  &:hover .dropdown {
    display: block;
  }
  i {
    color: #fff;
  }
`;

export const LinkButton2 = styled.a`
  display: flex;
  align-items: center;
  padding: 21px 25px;
  border-radius: 4px;
  font-family: ${({ theme }) => theme.fontIBMLight};
  border: 1px solid rgba(255, 255, 255, 0.4);
  transition: all 0.3s ease-in-out;
  :hover {
    border-color: #fff;
  }
  > div {
    line-height: 100%;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.7);
    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      display: inline-block;
      margin-bottom: 8px;
      font-family: ${({ theme }) => theme.fontIBMRegular};
    }
    strong {
      font-family: ${({ theme }) => theme.fontIBMBold};
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
    }
  }
`;

const DropDownWrap = styled.div`
  position: absolute;
  width: 100%;
  top: 14px;
  left: 0;
  margin-left: 0 !important;
  background: #0b0e11;
  border-radius: 3px;
  border: 1px solid #3a3e40;
  & div {
    padding: 18px 30px;
  }
  & div:hover {
    background: rgba(255, 255, 255, 0.06);
  }
  & div:hover a span,
  & div:hover a span i {
    color: #f0b90b;
  }
  & > div > a > span {
    margin-bottom: 0;
  }
`;
const BgDropDown = styled.div`
  height: 20px;
  width: 100%;
  position: absolute;
  top: 67px;
  left: 0;
  margin-left: 0 !important;
`;

type DropProps = {
  data: Array<Object>,
  className: String,
};

const DropDown = (props: DropProps) => (
  <DropDownWrap className={props.className}>
    {props.data.map(data => (
      <div>
        <a href={data.url}>
          <span>{data.icon}</span>&nbsp;&nbsp;<span>{data.text}</span>
        </a>
      </div>
    ))}
  </DropDownWrap>
);

const Windows = [
  {
    icon: <Icon type="Apple" size={16} color="#fff" />,
    text: 'MacOS',
    url: 'https://ftp.binance.com/desktop/Binance.dmg',
  },
  {
    icon: <Icon type="windows-fill" size={16} color="#fff" />,
    text: 'Windows',
    url: 'https://ftp.binance.com/pc_pack/Binance.exe',
  },
];
const App = [
  {
    icon: <Icon type="google-play-colors" size={16} color="#fff" />,
    text: 'Google Play',
    url: 'https://play.google.com/store/apps/details?id=com.binance.dev',
  },
  {
    icon: <Icon type="andriod" size={16} color="#fff" />,
    text: 'Android APK',
    url: 'https://ftp.binance.co/pack/Binance.apk',
  },
];

type Props = {
  i18n: Object,
  speed: Number,
  contentNumIs3: boolean,
};

export default
@withI18n
class DownloadPage extends Component<Props> {
  static defaultProps = {
    i18n: {},
    speed: 100,
    contentNumIs3: true,
  };

  componentDidMount() {
    const $app = document.querySelector('#app-img');
    const $mac = document.querySelector('#mac-img');
    const $api = document.querySelector('#api-img');
    const $macText = document.querySelector('#downloadMac');
    const $apiText = document.querySelector('#downloadApi');
    const controller = new ScrollMagic.Controller({
      refreshInterval: 500,
      globalSceneOptions: {
        triggerHook: 'onLeave',
      },
    });
    const stat = new TimelineMax();
    stat.to($apiText, 0, { visibility: 'hidden' }).to($app, 0, { x: 0 }, 0);

    const andriod = new TimelineMax();

    andriod
      .from($apiText, 0, { visibility: 'hidden' }, 0)
      .from($api, 0, { visibility: 'hidden' }, 0)
      .from($macText, 0, { y: 0, opacity: 1 }, 0)
      .fromTo($macText, 2, { opacity: 1 }, { opacity: 1 })
      .fromTo($mac, 0.01, { visibility: 'visible' }, { visibility: 'hidden' })
      .fromTo($api, 0.001, { visibility: 'hidden' }, { visibility: 'visible' })
      .fromTo($macText, 2, { y: 0, opacity: 1 }, { y: -700, opacity: 0 }, 3)
      .fromTo($apiText, 0.01, { visibility: 'hidden' }, { visibility: 'visible' }, 3.01)
      .fromTo($apiText, 2, { y: 700, opacity: 0 }, { y: 0, opacity: 1 }, 3)
      .to($app, 0, { x: 0 }, 0)
      .to($app, 2, { x: -60, ease: Power1.easeIn }, 2)
      .to($app, 1, { opacity: 0, x: -120, ease: Power1.easeOut });

    new ScrollMagic.Scene({
      duration: `${this.props.speed}%`,
      triggerElement: document.querySelector('#android'),
    })
      .setTween(andriod)
      .setPin('#android')
      .addTo(controller);
  }

  render() {
    const { i18n } = this.props;
    return (
      <Warp>
        <Container>
          <ItemBox id="android" align="center">
            <WrapImg className="top">
              <img id="app-img" src={require('./image/app-home.png')} alt="" />
            </WrapImg>
            <WrapImg className="top1">
              <img id="mac-img" src={require('./image/mac-home.png')} alt="" />
            </WrapImg>
            <WrapImg className="top2">
              <img id="api-img" src={require('./image/api-home.png')} alt="" />
            </WrapImg>
            <StyletContainer id="downloadMac">
              <ItemContent>
                <Title>{getLabel('exchange-index-exchangeEverywhere', i18n)}</Title>
                <Slogan>{getLabel('exchange-index-appDownloadDesc', i18n)}</Slogan>
                <LinkBox margin="10px 0 0">
                  <LinkButton white={true} target="_blank">
                    <Icon type="shouji" size={34} color="#fff" />
                    <div>
                      <span>{getLabel('exchange-index-downloadFor', i18n)}</span>
                      <br />
                      <strong>{getLabel('exchange-index-mobiles', i18n)}</strong>
                    </div>
                    <BgDropDown>
                      <DropDown className="dropdown" data={App} />
                    </BgDropDown>
                  </LinkButton>
                  <LinkButton white={true} target="_blank">
                    <Icon type="diannao-" size={30} color="#fff" />
                    <div>
                      <span>{getLabel('exchange-index-downloadFor', i18n)}</span>
                      <br />
                      <strong>{getLabel('exchange-index-windows', i18n)}</strong>
                    </div>
                    <BgDropDown>
                      <DropDown className="dropdown" data={Windows} />
                    </BgDropDown>
                  </LinkButton>
                </LinkBox>
              </ItemContent>
            </StyletContainer>
            <StyletContainer id="downloadApi">
              <ItemContent>
                <Title>{getLabel('exchange-home-integrationTitle', i18n)}</Title>
                <Slogan>{getLabel('exchange-home-integrationDesc', i18n)}</Slogan>
                <LinkBox margin="10px 0 0">
                  <LinkButton2
                    href="https://github.com/binance-exchange/binance-official-api-docs"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div>{getLabel('exchange-home-buttonText', i18n)}</div>
                  </LinkButton2>
                </LinkBox>
              </ItemContent>
            </StyletContainer>
          </ItemBox>
        </Container>
      </Warp>
    );
  }
}
